import type { ComponentProps } from 'react';

import styles from './new-item-tag.component.module.scss';

type Props = ComponentProps<'span'>;

export const NewItemTag = ({ className, ...rest }: Props) => (
  <span
    className={[styles.newItemTag, className].filter(Boolean).join(' ')}
    {...rest}
  />
);
